import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { setUserData } from "../../Redux/ActionCreater";
import axios from "axios";
import { BASE_IMAGE_URL, BASE_URL } from "../../config";
import { toast } from "react-toastify";
import { FaCamera } from "react-icons/fa";
import profileImage from "../../Assets/images/faces/face20.jpg";
function Sidebar() {
  const { userData } = useSelector(
    (state) => ({
      userData: state.dataReducer.userData,
    }),
    shallowEqual
  );
  let dispatch = useDispatch();
  let navigation = useNavigate();
  let [preImg, setImg] = useState("");
  let [image, setImage] = useState("");
  const ref = useRef(null);
  let uploadImage = async (file) => {
    try {
      let token = localStorage.getItem("token");
      let data = new FormData();
      data.append("profile_image", file);
      data.append("old_pic", userData.profile_pic);

      let header = {
        headers: {
          Authorization: token, //the token is a variable which holds the token
        },
      };

      await axios
        .post(`${BASE_URL}/user/update-profile-image`, data, header)
        .then((res) => {
          if (res.data.status === 200) {
            localStorage.setItem(
              "log_in_data",
              JSON.stringify({
                ...userData,
                profile_pic: res.data.data.profile_pic,
              })
            );
            dispatch(
              setUserData({
                ...userData,
                profile_pic: res.data.data.profile_pic,
              })
            );
            toast.success(res.data.message);
          } else {
            toast.error(res.data.message);
          }
        });
    } catch (error) {
      console.log(error, error.response.data);
      toast.error(error.response.data.responseText);
      setImg(userData.profile_pic);
      if (error.response.status === 401) {
        // dispatch(logout("warning", navigation, "/login", "Please log to continue!"));
      }
    }
  };

  let ImageChangeHandle = (e) => {
    console.log("object");
    const [file] = e.target.files;
    const fileType = file["type"];
    const validImageTypes = ["image/webp", "image/jpeg", "image/png"];
    if (file && validImageTypes.includes(fileType)) {
      setImage(file);
      uploadImage(file);
      e.target.value = "";
    } else {
      return toast.error("Please upload .png, jpeg or .webp file!");
    }
  };

  let logout = (e) => {
    e.preventDefault();
    localStorage.clear();
    dispatch(setUserData({}));
    toast.success("You are logged out successfully!");
    navigation("/");
  };

  useEffect(() => {
    userData.profile_pic ? setImg(userData.profile_pic) : setImg("");
  }, [userData]);
  const handleClickOutside = (event) => {
    if (window.innerWidth < 990) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        event.target.id != "toggleicon"
      ) {
        console.log(event.target);
        document.body.classList.remove("sidebar-icon-only");
      }
    }
  };

  useEffect(() => {
    // Add event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar" ref={ref}>
      <div
        className="profile-card"
        style={{ background: "#051F66", marginTop: 34 }}
      >
        <div className="card-body">
          <div className=" mb-4 h-100">
            <figure className="avatar mx-auto mb-4 mb-md-0">
              <img
                src={userData.picture ? userData.picture : profileImage}
                alt="avatar"
              />
            </figure>
            <h5
              className="text-white text-align-center mt-2"
              style={{ textAlign: "center" }}
            >
              {userData.name}
            </h5>
          {userData?.total_score&&userData?.total_score>0?  <h6
              className="text-white text-align-center mt-2"
              style={{ textAlign: "center" }}
            >
              API Score: {userData.total_score}
            </h6>:null}
          </div>
        </div>
      </div>
      <ul className="nav">
        <li className="nav-item">
          <NavLink
            onClick={(e) => {
              document.body.classList.remove("sidebar-icon-only");
            }}
            activeclassname={"active"}
            exact={"true"}
            className="nav-link"
            to="/dashboard"
          >
            <i className="typcn typcn-device-desktop menu-icon" />
            <span className="menu-title">My Dashboard</span>
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            onClick={(e) => {
              document.body.classList.remove("sidebar-icon-only");
            }}
            activeclassname={"active"}
            exact={"true"}
            className="nav-link"
            to="/edit-profile"
          >
            <i className="typcn typcn-contacts menu-icon" />
            <span className="menu-title">Edit Profile</span>
          </NavLink>
        </li>
        
        <li className="nav-item">
          <a
            className="nav-link"
            id="interview"
            data-bs-toggle="collapse"
            href="#manage"
            aria-expanded="false"
            aria-controls="charts"
          >
            <i className="typcn typcn-user menu-icon" />
            <span className="menu-title dropdownTitle">
              Performance Indicator
            </span>
            <i className="menu-arrow" />
          </a>
          <div className="collapse submenu" id="manage">
            <ul className="nav flex-column sub-menu">
              <li className="nav-item">
                {" "}
                <NavLink
                  onClick={(e) => {
                    document.body.classList.remove("sidebar-icon-only");
                  }}
                  className="nav-link"
                  to={"/academic-performance-indicator-step-1"}
                >
                  Activity Score
                </NavLink>
              </li>
              <li className="nav-item">
                {" "}
                <NavLink
                  onClick={(e) => {
                    document.body.classList.remove("sidebar-icon-only");
                  }}
                  className="nav-link"
                  to={"/academic-performance-indicator-step-2"}
                >
                  Research Score
                </NavLink>
              </li>
              <li className="nav-item">
                {" "}
                <NavLink
                  onClick={(e) => {
                    document.body.classList.remove("sidebar-icon-only");
                  }}
                  className="nav-link"
                  to={"/academic-performance-indicator-step-3"}
                >
                  Publications Score
                </NavLink>
              </li>
            </ul>
          </div>
        </li>
      
        <li className="nav-item">
          <NavLink
            onClick={(e) => {
              document.body.classList.remove("sidebar-icon-only");
            }}
            activeclassname={"active"}
            exact={"true"}
            className="nav-link"
            to="/change-password"
          >
            <i className="typcn typcn-home-outline menu-icon" />
            <span className="menu-title">Change Password</span>
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            onClick={(e) => {
              document.body.classList.remove("sidebar-icon-only");
            }}
            activeclassname={"active"}
            exact={"true"}
            className="nav-link"
            to="/applied-job"
          >
            <i className="typcn typcn-mortar-board menu-icon" />
            <span className="menu-title">Applied Jobs</span>
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink
            onClick={(e) => {
              document.body.classList.remove("sidebar-icon-only");
            }}
            activeclassname={"active"}
            exact={"true"}
            className="nav-link"
            to="/current-opening"
          >
            <i className="typcn typcn-home-outline menu-icon" />
            <span className="menu-title">Current Opening</span>
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Sidebar;
